/**
 * @file OperatorDropdown.js
 * @description A dropdown component for selecting an operator.
 */

import React, { useState, useEffect } from "react";
import { getOperators } from "../../../services/importService";
import { Dropdown } from "../../helpers/Dropdown";
import LoadingWrapper from "../../ui/loaders/LoadingWrapper";
import Toast from "../../ui/toasts/Toast";
import { getText } from '../../../i18n';

const OperatorDropdown = ({
  className,
  inlineLabel = true,
  selectedOperator,
  onOperatorChange,
  label = "",
  required = false,
}) => {
  const [operators, setOperators] = useState([]);
  const [defaultLabel, setDefaultLabel] = useState("Select Operator");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOperators = async () => {
      try {
        const data = await getOperators();
        setOperators(data);

        const matchingOperator =
          selectedOperator &&
          data.find((operator) => operator.id === selectedOperator.id);
        setDefaultLabel(
          matchingOperator ? matchingOperator.name : "Select Operator"
        );
      } catch (error) {
        console.error("Could not fetch operators:", error);
        Toast.error(getText('msg_87083517cbbf'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchOperators();
  }, []);

  useEffect(() => {
    if (selectedOperator && operators.length > 0) {
      const matchingOperator = operators.find(
        (operator) => operator.id === selectedOperator.id
      );
      setDefaultLabel(
        matchingOperator ? matchingOperator.name : "Select Operator"
      );
    } else {
      setDefaultLabel("Select Operator");
    }
  }, [selectedOperator, operators]);

  const operatorOptions = [
    { value: null, label: getText('msg_3ddf09fa60c5') },
    ...operators.map((operator) => ({
      value: { id: operator.id, name: operator.name },
      label: operator.name,
    })),
  ];

  return (
    <div
      className={`form-group ${
        inlineLabel ? "inline-input" : ""
      } ${className}`}
    >
      <>
        {label && (
          <label htmlFor="operator">
            {label}{required && <span className="text-danger">*</span>}
            {/* <span className="text-danger">*</span> */}
          </label>
        )}
        <LoadingWrapper isLoading={isLoading}>
          <Dropdown
            defaultValue={defaultLabel}
            options={operatorOptions}
            onChange={(value) => onOperatorChange(value)}
            value={selectedOperator}
            disabled={operators.length === 0 || isLoading}
          />
        </LoadingWrapper>
      </>
    </div>
  );
};

export default OperatorDropdown;
